import { Injectable } from '@angular/core';
import { environment } from '@ca/environment/environment';
import { TranslateService } from '@ngx-translate/core';
import { DatasetContributionEvent } from '../models/dataset-contribution-event.model';
import { SignalrService } from './signalr.service';
import { UserNotificationService } from './user-notification.service';

@Injectable({ providedIn: 'root' })
export class DatasetNotificationService {
    constructor(
        private signalRService: SignalrService,
        private userNotificationService: UserNotificationService,
        private translateService: TranslateService,
    ) {}

    establishWebsocketConnection(): void {
        const callback = (data: DatasetContributionEvent) => {
            if (data) {
                const messageArgs = {
                    datasetName: data.datasetName,
                    contributor: data.contributorName,
                };
                this.userNotificationService.showInfo(this.translateService.instant('MACHINE_LEARNING.DATASET.DATASET_MODIFIED_BY_CONTRIBUTOR', messageArgs));
            }
        };

        this.signalRService.startConnection(environment.websocketOrigin + '/datasetnotifications', 'DatasetContributionEvent', callback);
    }
}
